import type {
  NotificationBroadcastModelDeleteAsyncData,
  NotificationBroadcastModelDeleteAsyncFailedPayload,
  NotificationBroadcastModelDeleteAsyncSuccessPayload,
  NotificationBroadcastModelDeleteItem,
} from "../notification-broadcast.type";

import { isValidObject } from "@/utilities/object";

import { NOTIFICATION_BROADCAST_TYPE } from "../notification-broadcast.enum";
import { isValidNotificationBroadcastBase } from "../notification-broadcast.helper";

export const isNotificationBroadcastModelDeleteItem = (
  model: unknown
): model is NotificationBroadcastModelDeleteItem =>
  isValidObject(model) &&
  "id" in model &&
  typeof model.id === "number" &&
  "name" in model &&
  typeof model.name === "string" &&
  "type" in model &&
  typeof model.type === "string";

export const isNotificationBroadcastModelDeleteAsyncData = (
  payload: unknown
): payload is NotificationBroadcastModelDeleteAsyncData =>
  isValidObject(payload) &&
  "models" in payload &&
  Array.isArray(payload.models) &&
  payload.models.every((model) =>
    isNotificationBroadcastModelDeleteItem(model)
  ) &&
  "is_batch_processing" in payload &&
  typeof payload.is_batch_processing === "boolean";

export const isNotificationBroadcastModelDeleteAsyncSuccessPayload = (
  payload: unknown
): payload is NotificationBroadcastModelDeleteAsyncSuccessPayload =>
  isValidNotificationBroadcastBase(payload) &&
  isNotificationBroadcastModelDeleteAsyncData(payload) &&
  payload.event_type === NOTIFICATION_BROADCAST_TYPE.ASYNC_DELETE_SUCCESS;

export const isNotificationBroadcastModelDeleteAsyncFailedPayload = (
  payload: unknown
): payload is NotificationBroadcastModelDeleteAsyncFailedPayload =>
  isValidNotificationBroadcastBase(payload) &&
  isNotificationBroadcastModelDeleteAsyncData(payload) &&
  payload.event_type === NOTIFICATION_BROADCAST_TYPE.ASYNC_DELETE_FAILED;
